export enum AccordionTheme {
  DEFAULT,
  OPPORTUNITY,
  REVENUE,
  CONVERSIONS
}

export interface AccordionThemeClasses {
  backgroundColourClass?: string;
  borderColourClass?: string;
}
